import { cn } from "@/lib/utils";
import { MotionProps } from "framer-motion";
import React from "react";
import Balancer from "react-wrap-balancer";

export const Subheading = ({
  className,
  as: Tag = "h2",
  children,
  ...props
}: {
  className?: string;
  as?: any;
  children: any;
  props?: React.HTMLAttributes<HTMLHeadingElement | MotionProps>;
} & MotionProps &
  React.HTMLAttributes<HTMLHeadingElement | MotionProps>) => {
  return (
    <Tag
      className={cn(
        "text-sm md:text-base  max-w-4xl text-left my-4 mx-auto",
        "text-muted text-center font-normal font-sans",
        className
      )}
    >
      <Balancer>{children}</Balancer>
    </Tag>
  );
};